export const isRegistrationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REGISTRATION !== "false";

export const isSongVerificationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_SONG_VERIFICATION !== "false";

export const isWazaAirEnabled =
  process.env.NEXT_PUBLIC_ENABLE_WAZA_AIR !== "false";

export const isPublicAnalyticsEnabled =
  process.env.NEXT_PUBLIC_ENABLE_PUBLIC_ANALYTICS !== "false";

// FEATURE-129: kill-switch de Google Sign-In. Default DESACTIVADO (opt-in):
// solo se habilita si la env var vale exactamente "true".
export const isGoogleAuthEnabled =
  process.env.NEXT_PUBLIC_ENABLE_GOOGLE_AUTH === "true";
